<div [ngClass]="'rem-bg-light rem-text-default border-round-md py-1 px-2 cursor-pointer '+styleClass" 
     pTooltip="pTooltip" 
     tooltipPosition="tooltipPosition" 
     (click)="click.emit()">
  <i [ngClass]="'text-xs pi pi-'+icon"></i>
</div>
